module.exports = __webpack_public_path__ + "static/media/纸模型电子琴.7834302b.png";